export class ClientIds {
    static newId() {
        return crypto.randomUUID();
    }
}
//# sourceMappingURL=ids.js.map